<app-label-initializer></app-label-initializer>
<mat-sidenav-container class="app-shell">
  <mat-sidenav #sidenav [mode]="mode_sidenav" opened class="app-sidebar">
    <app-menu></app-menu>
  </mat-sidenav>
  <mat-sidenav-content class="app-shell-content">
    <div class="app-main-column">
      <app-header-home>
        <button type="button" class="app-sidenav-toggle a_clean" (click)="toggleDrawer()" aria-label="Apri o chiudi menu">
          <app-icons [tipoIcona]="2" [ariahiddenValue]="'false'" [srcIcon]="'loghi/W_icon.png'" [widthValue]="'40'" [heightValue]="'40'"></app-icons>
        </button>
      </app-header-home>
      @if ((viewTitle$ | async) === 1 && (title$ | async) != 'Home') {
        <div class="app-page-title-bar">
          <h5 class="app-page-title">{{ title$ | async }}</h5>
          <div class="app-page-title-actions"></div>
        </div>
      }
      <div class="app-shell-router pb-5 container_global" [ngClass]="{ 'app-shell-router--tight': (viewTitle$ | async) === 0 }">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-assistant-panel></app-assistant-panel>
